/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';

import TopBar from '../../components/TopBar'
import { DataTableList } from '../../components/DataTable/DataTableList';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';
import { deleteBlogs, getBlogs } from '../../api/blogApi';
import { getAllBlogCategories } from '../../api/blogCategoryApi';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import down from "../../assets/images/icondropdown.svg";
import searchIcon from "../../assets/images/icon-search.svg";

import styles from './blog.module.css'

const AllPosts = () => {
  const popupRef = useRef()
  const dropdownRef = useRef()

  const [blogList, setBlogList] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [columnWidths, setColumnWidths] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [toggleSelect, setToggleSelect] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Dropdown states
  const [open, setOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryList, setCategoryList] = useState([])

  const [searchInput, setSearchInput] = useState('');

  // Categories list
  const fetchCategoryData = async () => {
    try {
      const response = await getAllBlogCategories();
      if (response?.success) {
        setCategoryList(response?.data || []);
      }
    } catch (error) {
      console.log({ error })
    }
  }

  useEffect(() => {
    fetchCategoryData()
  }, [])

  const fetchData = async () => {
    try {
      setIsLoadingData(true);
      const response = await getBlogs({
        page: currentPage,
        search: searchInput,
        sortBy: 'createdAt',
        category: selectedCategories?.map(item => item?.categoryId).join(','),
      });

      if (response?.data?.result?.length <= 0) {
        setIsLoadingData(false);
      }
      setBlogList(response?.data?.result || []);
      setTotalPage(response?.data?.totalPages || 1);
    } catch (error) {
      console.error('Error loading blogs:', error);
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, selectedCategories]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowDeletePopup(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const calculateColumnWidths = async () => {
    return new Promise((resolve) => {
      const tempWidths = blogList?.reduce((acc, row) => {
        Object.keys(row).forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];
          let maxContentLength = Math.max(dataValue?.length, title?.length);
          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});

      if (tempWidths !== undefined) {
        const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
          acc[key] = `${tempWidths[key] * 10 + 40}px`;
          return acc;
        }, {});
        setColumnWidths(widthMap);
      }
      resolve();
    });
  };

  useEffect(() => {
    if (blogList?.length > 0) {
      calculateColumnWidths();
    }
  }, [blogList]);

  useEffect(() => {
    if (Object.keys(columnWidths).length > 0) {
      setTimeout(() => {
        setIsLoadingData(false);
      }, 1000);
    }
  }, [columnWidths]);

  const handleCategoryChange = (category) => {
    setSelectedCategories(prev => {
      if (prev.includes(category)) {
        const filtered = prev.filter(c => c !== category);
        return filtered.length === 0 ? [] : filtered;
      } else {
        return prev?.length === 0
          ? [category]
          : [...prev, category];
      }
    });
  };

  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(blogList?.map((row) => row?.blogId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const columns = [
    {
      name: 'Title',
      selector: (row) => row?.title,
      cell: (row) => <div className='editTitle'><Link to={`/blog/${row?.blogId}`}>{row.title}</Link></div>,
      sortable: true,
      minWidth: columnWidths['title'] ? `${parseInt(columnWidths['title']) + 50}px` : '200px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px", color: '#000' },
    },
    {
      name: 'Status',
      selector: (row) => row?.status,
      cell: (row) => (
        <span className={`status-badge ${row.status}`}>
          {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
        </span>
      ),
      sortable: true,
      width: '150px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Date',
      selector: (row) => row?.createdAt,
      cell: (row) => <div>{moment(row.createdAt).tz("Asia/Kolkata").format("MMM DD, YYYY")}</div>,
      sortable: true,
      width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 130}px` : '200px',
      style: { width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 130}px` : '200px', paddingTop: "15px", paddingBottom: "15px", fontSize: "14px", paddingLeft: 0 },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="action-buttons">
          <Link to={`/blog/${row?.blogId}`}><button className="edit-btn"><img src={penIcon} alt="pen-icon" /></button></Link>
          <button className="delete-btn" onClick={() => {
            setDeleteTarget({ type: "single", row });
            setShowDeletePopup(true);
          }}><img src={Delete} alt="delete-icon" /></button>
        </div>
      ),
      width: "90px"
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
      },
    },
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      setIsLoading(true);
      if (deleteTarget.type === "single") {
        const response = await deleteBlogs([deleteTarget?.row?.blogId]);
        if (response?.success) {
          setSelectedRows([]);
          setIsAllSelected(false);
          setToggleSelect(prev => !prev);
          setShowDeletePopup(false);
          setDeleteTarget(null);
          await fetchData()
        }
      }
      if (deleteTarget.type === "multiple") {
        const response = await deleteBlogs(deleteTarget?.rows);
        if (response?.success) {
          setSelectedRows([]);
          setIsAllSelected(false);
          setToggleSelect(prev => !prev);
          setShowDeletePopup(false);
          setDeleteTarget(null);
          await fetchData()
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('Error deleting blogs:', error);
    }
  };

  const handleSearch = async () => {
    fetchData();
  }

  return (
    <div className={`blog-list ${styles.productList} ${blogList?.length <= 10 && `${styles.productListHeight}`}`}>
      <TopBar />
      <div className={`${styles.productDatatableList}`}>
        <div className={`${styles.productHeader}`}>
          <div className={`${styles.leftSide}`}>
            <div className={`${styles.searchBar}`}>
              <img src={searchIcon} alt="Search" />
              <input
                type="text"
                placeholder="Search by blog title..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              />
            </div>
            <button className={`${styles.addBtn}`} onClick={() => handleSearch()}>Search</button>
          </div>
          <div className={`${styles.actionButtonsDeleteAdd}`}>
            {categoryList && categoryList.length > 0 && (
              <div className="dropdown-wrapper" ref={dropdownRef}>
                <div className="dropdown-header" onClick={() => setOpen(!open)}>
                  <span className="title">Categories</span>
                  <span className={`arrow ${open ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                </div>
                {open && (
                  <div className="dropdown-list">
                    {categoryList?.map((cat, index) => (
                      <label key={index}
                        onChange={() => handleCategoryChange(cat)}
                        className="dropdown-item" >
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(cat)}
                        />
                        <span>{cat?.name}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            )}
            <Link to='/new-blog'><button className={`${styles.addBtn}`}>Add Blog</button></Link>
            {selectedRows?.length > 0 && (
              <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                setDeleteTarget({ type: "multiple", rows: selectedRows });
                setShowDeletePopup(true);
              }}>
                <img src={Delete} alt="delete-icon" />
              </div>
            )}
          </div>
        </div>

        <div className={`blogTable dataTable-list ${blogList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
          <DataTableList
            columns={columns}
            data={blogList}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows.map((row) => row.blogId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds.length === blogList.length);
            }}
            progressPending={isLoadingData}
            currentPage={currentPage}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            selectableRows
            selectAllRows={isAllSelected}
            clearSelectedRows={toggleSelect}
            onSelectAllChange={handleMasterCheckboxChange}
            customStyles={customStyles}
            selectableRowsComponent="input"
            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
          />
        </div>
      </div>
      <DeleteConfirmationPopup
        showDeletePopup={showDeletePopup}
        setShowDeletePopup={setShowDeletePopup}
        reference={popupRef}
        title={deleteTarget?.type === "single" ? 'blog' : selectedRows?.length === 1 ? 'blog' : `blogs`}
        description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.title}?` : selectedRows?.length === 1 ? `Are you sure you want to delete blog?` : `Are you sure you want to delete ${selectedRows?.length} blogs?`}
        confirmDelete={confirmDelete}
        isLoading={isLoading}
      />
    </div>
  )
}

export default AllPosts
